import { useParams } from 'react-router';
import { TasksProject, TasklineRowType } from '@views/project';
import { GetTasksPayloadType } from '@api';
import { useEffect } from 'react';
import { useDelayedEffect, useRequestParams } from '@hooks';

import { store } from '@/store';

const TasksProjectPage = () => {
  const { projectId } = useParams();

  const tasksFiltered = store.use.tasksFiltered();

  const getTasksAction = store.use.getTasksAction().call;

  const { afterPageChange, pagination, onTableStateChange, reqParams, setParams } = useRequestParams<
    GetTasksPayloadType['filters'],
    TasklineRowType
  >({
    initParams: { model: {} },
  });

  useDelayedEffect(() => {
    getTasksAction({ idProject: projectId, filters: reqParams });
  }, [JSON.stringify(reqParams)]);

  useEffect(() => {
    afterPageChange(tasksFiltered.length);
  }, [tasksFiltered.length]);

  return (
    <TasksProject
      tableProps={{ pagination, onChange: onTableStateChange }}
      tasks={tasksFiltered}
      onFiltersChange={setParams}
    />
  );
};

export default TasksProjectPage;
